import React from 'react';
import { getBaseURL, TENANT_KEY } from '../../../../utility/env';

const REGA_URL =
  'https://eservicesredp.rega.gov.sa/auth/queries/Brokerage/BrokerageDetails/WB2Ma9gyrGeW4VLQR6NO/BrokerType_Office';
const SOCIAL_NAMES = ['facebook', 'twitter', 'linkedin', 'instagram'];

// Mobile footer for the bayut tenant; structure and spacing mirror the bayut.sa mobile footer.
export const FooterMobileBayut = ({ locale, socialLinks, copyright }) => (
  <>
    <div className="mobile-footer-content">
      <div className="mobile-footer-badges">
        <a className="mobile-footer-badge" target="_blank" href={REGA_URL} rel="noreferrer">
          <img src={`${getBaseURL()}/profolio-assets/${TENANT_KEY}/lite/rega-fal-badge-v2.svg`} alt="" />
        </a>
        <span className="mobile-footer-badge">
          <img src={`${getBaseURL()}/profolio-assets/${TENANT_KEY}/lite/tourism-mot-${locale}.svg`} alt="" />
        </span>
      </div>
      <div className="mobile-footer-socials">
        {socialLinks.map(({ href }, index) => (
          <div className="mobile-footer-social" key={href}>
            <a href={href} aria-label={SOCIAL_NAMES[index]}>
              <span className={`mobile-footer-social-icon mobile-footer-social-${SOCIAL_NAMES[index]}`} />
            </a>
          </div>
        ))}
      </div>
    </div>
    <div className="mobile-footer-copyright">{copyright}</div>
  </>
);
